import type { IconProps } from './types';

export const UnderlineIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      className={className}
    >
      <path
        d="M16.7145 17.6067L16.7906 17.6106C17.1689 17.6488 17.4643 17.9684 17.4645 18.3567C17.4645 18.7452 17.169 19.0646 16.7906 19.1028L16.7145 19.1067H1.28577C0.871553 19.1067 0.535767 18.7709 0.535767 18.3567C0.535992 17.9427 0.871692 17.6067 1.28577 17.6067H16.7145ZM3.74963 10.0003V1.64286C3.74963 1.22878 4.08561 0.893083 4.49963 0.892857C4.91385 0.892857 5.24963 1.22864 5.24963 1.64286V10.0003C5.24978 12.0711 6.92885 13.7501 8.99963 13.7503C11.0706 13.7503 12.7495 12.0712 12.7496 10.0003V1.64286C12.7496 1.22878 13.0856 0.893083 13.4996 0.892857C13.9138 0.892857 14.2496 1.22864 14.2496 1.64286V10.0003C14.2495 12.8996 11.899 15.2503 8.99963 15.2503C6.10042 15.2501 3.74978 12.8995 3.74963 10.0003Z"
        fill={color}
      />
    </svg>
  );
};
